export const APP_ROUTES = {
  default: '/prospecting-list',
  catchAll: '*',
} as const;
